//配置全局访问接口地址
let commonUrl = "//apiflow.trendfut.com";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl